import "./Loading.css"
export function Loading(){
    return(
        <div id='loader'></div>
    )
}